import type {
  TAlertsManagerSerializedInternalState,
  AlertsManagerWidgetEntity,
} from '../../../pages/dashboard/features/alerts-manager-widget/AlertsManagerWidget.entity';

export function serializeAlertsManagerTemplate(widget: AlertsManagerWidgetEntity) {
  const internalState: TAlertsManagerSerializedInternalState = {
    wellId: null,
    stateParams: widget.stateParams,
    isEditMode: widget.isEditMode,
  };
  return {
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    internalState,
  };
}
